import React, { Component } from "react";
import { uploadList } from "./Configs/uploadList";
import "./index.scss";
import BackIcon from "./svgs/backIcon.svg";
import { Collapse } from "@material-ui/core";
import AxiosClient from "../../Network/AxiosClient";
import { upload_tabs } from "./Configs/filterConfigs";
import SearchBar from "./Components/searchBar";
import UploadModule from "./Components/uploadModule";
import { Redirect } from "react-router-dom";

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

function formatWords(str) {
  var newString = str.replace(/_/g, " ");
  return capitalizeFirstLetter(newString);
}

export default class NewUpload extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      filter: null,
      currentReport: null,
      history: [],
      tableData: [],
      currentGroup: upload_tabs[0],
      searchTerm: "",
      filterConfigs: {},
    };
  }

  componentDidMount() {
    const localUserToken = JSON.parse(localStorage.getItem("currUserToken"));
    if (localUserToken) this.getUploadHistory();
  }
  getUploadHistory = () => {
    AxiosClient.get(
      `${process.env.REACT_APP_API_URL}/api/uploads/v1/upload-list?page_index=0&page_size=1000`,
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
        },
      },
    )
      .then((res) => {
        this.setState({ history: res.data.data });
      })
      .catch((err) => {
        console.log(err);
      });
  };
  toggleDrawer = (report) => {
    this.setState((prevState) => ({
      currentReport: prevState.currentReport
        ? null
        : {
            ...report,
            fields: prevState.filterConfigs[report.key],
          },
    }));
  };

  filteUserTypePermission = (i) => {
    const user_type = JSON.parse(localStorage.getItem("currUserType"));
    var filterPass = false;
    if (!i.userTypes) return true;
    if (i.userTypes)
      i.userTypes.map((userType) => {
        if (userType === user_type) filterPass = true;
      });
    return filterPass;
  };

  filteUserScope = (i) => {
    const user_scope = localStorage.getItem("scope");
    var currentReportScope = i.scope ? i.scope : "merchant_business";
    return user_scope === currentReportScope;
  };

  onChangeGroup = (tab) => {
    this.setState({ currentGroup: tab });
  };

  filterCurrentGroup = (upload) => {
    const user_scope = localStorage.getItem("scope");
    if (user_scope === "online") return true;
    if (this.state.currentGroup === "all") return true;
    return upload.group && upload.group === this.state.currentGroup;
  };
  filterSearchTerm = (upload) => {
    if (this.state.searchTerm === "") return true;
    return upload.title.toLowerCase().includes(this.state.searchTerm);
  };
  onSearch = (e) => {
    this.setState({ searchTerm: e.target.value });
  };
  render() {
    const localUserToken = JSON.parse(localStorage.getItem("currUserToken"));
    if (!localUserToken) return <Redirect to="/signin" />;
    const user_scope = localStorage.getItem("scope");

    return (
      <div className="main-container new-upload-container">
        <ReportTabInfo
          report={this.state.currentReport}
          onBack={this.toggleDrawer}
        />
        <div className="report-layout">
          <div className="reports-list-container">
            <div className="reports-list-top-bar">
              <SearchBar
                value={this.state.searchTerm}
                onChange={this.onSearch}
              />
              {user_scope === "merchant_business" && (
                <ReportGroups
                  tabs={upload_tabs}
                  current={this.state.currentGroup}
                  onChange={this.onChangeGroup}
                />
              )}
            </div>
            {uploadList
              .filter(this.filteUserScope)
              .filter(this.filteUserTypePermission)
              .filter(this.filterCurrentGroup)
              .filter(this.filterSearchTerm)
              .map((upload, index) => (
                <UploadModule
                  key={upload.title}
                  upload={upload}
                  index={index}
                  historyData={this.state.history}
                />
              ))}
          </div>
        </div>
      </div>
    );
  }
}

function ReportGroups({ tabs, current, onChange }) {
  return (
    <div className="report-group-tabs">
      {tabs.map((tab) => (
        <button
          disabled={!uploadList.find((r) => r.group === tab || tab == "all")}
          className={tab === current ? "active" : ""}
          key={tab}
          onClick={() => onChange(tab)}
        >
          <p>{formatWords(tab)}</p>
        </button>
      ))}
    </div>
  );
}

function ReportTabInfo({ report, onBack }) {
  return (
    <div className="page-title">
      {report && (
        <Collapse in={report ? true : false}>
          <div className="page-title-container">
            <button onClick={onBack}>
              <img src={BackIcon} alt="Back Icon" />
            </button>
            {report && (
              <div className="report-id report-index">
                {String(report.index + 1).padStart(2, "0")}.
              </div>
            )}
          </div>
        </Collapse>
      )}
      {report ? report.name : "Uploads"}
    </div>
  );
}
